import { AviaSearchParameters } from '@websky/graphql';
import { PassengerType } from '../enums';
import { Locale } from '../types';
import { SearchFormState } from './store/reducers';
import { z } from 'zod';
import { PassengerConfigSegmentSchema, PassengerTypeConfigSchema } from '../configSchema/SearchFormSchema';

export interface CachedSearchFormState {
	locale?: Locale;
	state?: SearchFormState;
}

export type PassengerConfigSegment = z.infer<typeof PassengerConfigSegmentSchema>;

export type PassengerTypeConfig = z.infer<typeof PassengerTypeConfigSchema>;

export interface Passenger {
	type: PassengerType;
	count: number;
}

export enum LocationType {
	Departure = 'departure',
	Arrival = 'arrival'
}

export type SubmitFormHandler = (params: AviaSearchParameters) => void;
